
export * from '../../asset-taglib/__liferay__/index.js';
